import React, { useState } from 'react';
//import { makeStyles } from '@mui/styles';
import { useRecoilState, useRecoilValue } from 'recoil';
import { Dialog, Slide } from '@mui/material';
import { openProjectNameAtom, mobileAtom } from '../Atoms';
//import { useIntl } from 'react-intl';
import MobileNavbar from './MobileNavbar';
//import RadarChart from '../RadarChart';
import InternalList from './InternalList';
import ExternalList from './ExternalList';
import '../../css/App.scss';
import MobileRadarBox from './MobileRadarBox';

const Transition = React.forwardRef(function Transition(props, ref) {
  // eslint-disable-next-line react/jsx-props-no-spreading
  return <Slide direction="up" ref={ref} {...props} />;
});

function TabPanel(props) {
  // eslint-disable-next-line react/prop-types
  const { children, value, index } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      // eslint-disable-next-line react/jsx-props-no-spreading
    >
      {value === index && <div>{children}</div>}
    </div>
  );
}

//const useStyles = makeStyles({});

const HomePageMobile = function HomePageMobile() {
  //const classes = useStyles();
  const [sectionValue, setSectionValue] = useState(0);
  const [openProjectName, setOpenProjectName] = useRecoilState(openProjectNameAtom);
  const mobile = useRecoilValue(mobileAtom);

  const handleChangeDialogSection = (event, newValue) => {
    setSectionValue(newValue);
  };
  //const intl = useIntl();

  return (
    <Dialog
      fullScreen
      open={openProjectName && mobile}
      onClose={() => {
        setOpenProjectName(null);
      }}
      TransitionComponent={Transition}
      className="mobileDialog"
    >
      <MobileNavbar changeSection={handleChangeDialogSection} sectionValue={sectionValue} />
      <TabPanel value={sectionValue} index={0}>
        <InternalList />
      </TabPanel>
      <TabPanel value={sectionValue} index={1}>
        <ExternalList />
      </TabPanel>
      <TabPanel value={sectionValue} index={2}>
        <MobileRadarBox />
      </TabPanel>
    </Dialog>
  );
};
export default HomePageMobile;
